import React from 'react';

const SignedOut: React.FC = () => {
  const handleSignIn = () => {
    window.location.href = '/';
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: '#f5f5f5',
      fontFamily: 'Inter, system-ui, sans-serif'
    }}>
      <img
        src="/joule-logo.png"
        alt="Joule"
        style={{ height: '2.5rem', marginBottom: '2rem' }}
      />
      <div style={{
        backgroundColor: 'white',
        padding: '3rem',
        borderRadius: '0.5rem',
        boxShadow: '0 0.125rem 0.5rem rgba(0,0,0,0.1)',
        textAlign: 'center',
        maxWidth: '28rem'
      }}>
        <h2 style={{ margin: '0 0 1rem 0', color: '#333', fontSize: '1.25rem' }}>
          You have been signed out
        </h2>
        <p style={{ color: '#666', marginBottom: '2rem', fontSize: '0.875rem', lineHeight: '1.5' }}>
          Your session has ended. You can close this tab or sign in again.
        </p>
        <button
          onClick={handleSignIn}
          style={{
            backgroundColor: '#1a1a2e',
            color: 'white',
            border: 'none',
            padding: '0.625rem 1.5rem',
            borderRadius: '0.25rem',
            cursor: 'pointer',
            fontSize: '0.875rem'
          }}
        >
          Sign in again
        </button>
      </div>
    </div>
  );
};

export default SignedOut;
